import React, { useState, useEffect } from "react";
import { RESOURCES_DATA as RESOURCES_FALLBACK } from "./Detailconstants.js";
import { fetchContent } from "../../../../services/contentService";

export default function ResourcesSection() {
  const [resources, setResources] = useState(RESOURCES_FALLBACK);
  const [openGroups, setOpenGroups] = useState({});
  useEffect(() => {
    fetchContent("visaDetail").then(section => {
      if (section?.content?.resources) setResources(section.content.resources);
    }).catch(() => {});
  }, []);

  const toggleGroup = (id) => {
    setOpenGroups((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <section className="VF-resources-section" id="resources" aria-label="Resources and Official Links">
      <div className="VF-container">
        <header className="VF-section-header VF-section-header--center" data-aos="fade-up">
          <h2 className="VF-heading-lg">Official Resources &amp; Support</h2>
          <span className="VF-divider VF-divider--center" aria-hidden="true" />
          <p>
            Direct links to government portals, helplines, and quick navigation — everything you need in one place.
          </p>
        </header>

        <div className="VF-resources-grid" data-aos="fade-up" data-aos-delay="80">
          {resources.map((group) => (
            <div key={group.id} className="VF-resource-card">
              <button
                type="button"
                className="VF-resource-card__title"
                onClick={() => toggleGroup(group.id)}
                aria-expanded={!!openGroups[group.id]}
              >
                {group.title}
                <svg className="VF-resource-card__arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </button>
              <div className={`VF-resource-links-wrapper${openGroups[group.id] ? ' VF-resource-links-wrapper--open' : ''}`}>
                <ul className="VF-resource-links">
                  {group.links.map((link) => (
                    <li key={link.href + link.label}>
                      <a
                        href={link.href}
                        className="VF-resource-link"
                        target={link.href.startsWith("http") ? "_blank" : undefined}
                        rel={link.href.startsWith("http") ? "noopener noreferrer" : undefined}
                      >
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                          {link.href.startsWith("http") ? (
                            <>
                              <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                              <polyline points="15 3 21 3 21 9" />
                              <line x1="10" y1="14" x2="21" y2="3" />
                            </>
                          ) : (
                            <polyline points="9 18 15 12 9 6" />
                          )}
                        </svg>
                        <span>
                          <span className="VF-resource-link__label">{link.label}</span>
                          <span className="VF-resource-link__desc">{link.desc}</span>
                        </span>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}